import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import ValidationForm from './ValidationForm';

export default function TankCard(props) {
  const { t } = useTranslation();
  const {
    setLoadingState, tankPath, tankNumber, certificate, cellar,
    validation, verify, dispatchMenuActions, tankName, cellarName,
  } = props;
  const certificateDate = certificate.expirationDate;
  const certificateExpired = certificateDate < new Date();
  const { hasBeenChecked, isValid } = validation;
  const dateColor = certificateExpired ? 'red' : 'black';
  const [displayVerify, setdisplayVerify] = useState(!hasBeenChecked);

  useEffect(() => {
    const verifyCertificateAction = {
      name: t('tank_selection.verify_procedure'),
      callback: () => setdisplayVerify(true),
    };
    dispatchMenuActions({ type: 'add', actions: [verifyCertificateAction] });
  }, [dispatchMenuActions, t]);

  const verifyAndDisplay = (newValidation) => {
    setdisplayVerify(false);
    verify(newValidation);
  };

  return (
    <Paper sx={{ minWidth: 275, p: 3 }} elevation={0}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box sx={{ flexDirection: 'column' }}>
          <WarehouseIcon sx={{ fontSize: 60, color: 'primary.main' }} />
          <Typography
            variant="subtitle1"
            component="div"
            sx={{ color: '#437A89' }}
          >
            {cellarName}
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="body2" component="span">
            {t('tank_selection.tank')}
            {': '}
            {tankName || tankNumber}
            <br />
            {t('tank_selection.certificate')}
            {': '}
            {certificate.certificateName || certificate.id}
            <br />
            {t('tank_selection.valid_until')}
            {': '}
            <Typography variant="body2" component="span" sx={{ color: dateColor }}>
              {certificateDate.toLocaleDateString()}
            </Typography>
            <br />
            {hasBeenChecked && (
              <Typography variant="body2">
                {t('tank_selection.checked_by')}
                {': '}
                {validation.operator}
              </Typography>
            )}
          </Typography>
        </Box>
      </Box>
      {certificateExpired && (
        <Alert
          sx={{
            padding: 1, mt: 2, justifyContent: 'center',
          }}
          severity="warning"
        >
          {t('tank_selection.certificate_expired')}
        </Alert>
      )}
      {displayVerify && (
        <ValidationForm
          tankPath={tankPath}
          tankNumber={tankNumber}
          certificateNumber={certificate.id}
          cellar={cellar}
          setLoadingState={setLoadingState}
          verify={verifyAndDisplay}
          tankName={tankName}
          cellarName={cellarName}
          certificateName={certificate.certificateName || certificate.id}
        />
      )}
      {hasBeenChecked && !isValid && (
        <Alert
          sx={{
            padding: 1, mt: 2, justifyContent: 'center',
          }}
          severity="error"
        >
          {t('tank_selection.certificate_invalid')}
        </Alert>
      )}
    </Paper>
  );
}
